export const fallBackLogger = {
    noticeError: (error, customAttributes)=>{
        if (process.env.NODE_ENV !== 'test') {
            return console.error({
                error,
                customAttributes
            });
        }
    },
    addPageAction: (actionName, attributes)=>{
        if (process.env.NODE_ENV !== 'test') {
            return console.error({
                actionName,
                attributes
            });
        }
    },
    setCustomAttribute: (name, value)=>console.error({
            name,
            value
        }),
    setPageViewName: (name, host)=>console.error({
            name,
            host
        }),
    setErrorHandler: ()=>console.error('setNewRelicErrorHandler')
};
// Returns either new relic instance from window object or fallback logger
const getNewRelicInstance = ()=>// we need to return fallBackLogger in case window.newRelic is unavailable
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    typeof window !== 'undefined' && window.newrelic ? window.newrelic : fallBackLogger;
export default getNewRelicInstance;
